<template>
    <b-overlay :show="loading" rounded="sm">
    <b-card body-class="px-0">
        <h1 class="font-weight-bold">{{ $translate('services') }}</h1>
        <div>
            <b-row class="mt-3">
                <b-col>
                   
                    <b-tabs card align="center" v-model="isCompleted">
                        <b-tab :title="$translate('draft')" class="d-none"> </b-tab>
                        <b-tab :title="$translate('active')" class="d-none"> </b-tab>
                        <b-tab :title="$translate('completed')" class="d-none"> </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
            <b-row class="mt-2 mt-lg-0">
                <b-col cols="9" md="6" class="text-right d-flex align-items-end">
                    <b-button id="create-service-btn" variant="blue-button" class="mr-4" @click="createService()">
                        <b-icon-plus-circle variant="light" class="mr-1">
                        </b-icon-plus-circle>
                        {{ $createLabel() }}
                    </b-button>
                    <b-button id="filter-service-btn" @click="showFilter = !showFilter" variant="none" class="ms-2 blue-button">
                        {{ $translate('filter') }}
                        <b-icon class="ms-1" :icon="'chevron-' + (showFilter ? 'up' : 'down')" variant="dark"></b-icon>
                    </b-button>
                </b-col>
                <b-col cols="3" md="3" class="text-right d-flex align-items-end justify-content-end">
                    <b-button id="user-btn" variant="blue-button" class="mr-4" @click="users()">
                        {{ $translate('users') }}
                    </b-button>
                </b-col>
                <b-col cols="12" md="3" class="mt-2 dd">
                    <label for="input-perPage" class="mb-2"><strong>{{ $translate('per_page') }}:</strong></label>
                    <b-form-select class="form-control" id="input-perPage" v-model="perPage"
                        :options="[3, 5, 10, 20]"></b-form-select>
                </b-col>
            </b-row>

            <b-row>
                <service-filter v-model="filters" v-show="showFilter" />
            </b-row>
        </div>
        <hr />
        <b-row class="justify-content-md-center">
            <b-col>
                <strong>
                    {{
                        `${this.$translate('page')} ${currentPage} ${this.$translate('of')} ${Math.ceil(
                            rows / perPage
                        )} ${this.$translate('total')}:
                                        ${rows}`
                    }}
                </strong>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="overflow-auto w-100 mt-4">
                <div class="table-responsive">
                    <table class="table b-table" :style="customColor">
                        <thead>
                            <th v-for="item in fields" :key="item.id">
                                {{ item.label }}
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="order in orders" :key="order.id">
                                <td aria-colindex="1">
                                    <b-button v-if="isCompleted == 0" :id="'view-service-btn'+order.id" @click="gotoEdit(order.id)" class="mr-2 test-view-service-btn" variant="pink-button">
                                        <img src="@/assets/images/icon/view.svg" />
                                    </b-button>
                                    <b-button v-else :id="'view-service-btn'+order.id" @click="gotoDetails(order.id)" class="mr-2 test-view-service-btn" variant="pink-button">
                                        <img src="@/assets/images/icon/view.svg" />
                                    </b-button>
                                </td>
                                <td>{{ order.reference_no }}</td>
                                <td aria-colindex="2">
                                    {{ order.type && (order.type.customer_portal_name || order.type.name) }}
                                </td>
                                <td aria-colindex="2">
                                    {{ order.category && order.category.name }}
                                </td>
                                <td aria-colindex="2">
                                    {{ order.description }}
                                </td>
                                <td aria-colindex="2">
                                    {{
                                        !order.created_at
                                        ? ''
                                        : formatDateTime(order.created_at)
                                    }}
                                </td>
                                <td aria-colindex="2">
                                    {{
                                        !order.completed_at
                                        ? ''
                                        : formatDateTime(order.completed_at)
                                    }}
                                </td>
                                <td aria-colindex="2">
                                    {{ officerUser(order) }}
                                </td>
                                <td aria-colindex="2">
                                    {{ calculateOrderPrice(order)  | formatPrice}}
                                 </td>
                                <td aria-colindex="2">
                                    <h6>
                                        <b-badge
                                            :variant="order | filterStatusVariant"
                                            >{{ filterStatusName(order) }}</b-badge
                                        >
                                    </h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <b-row>
                    <b-col>
                        <b-pagination class="mt-5" :prev-text="$translate('previous')" :next-text="$translate('next')"
                            v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center"
                            aria-controls="my-table"></b-pagination>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

// import ServiceSummary from './ServiceSummary'
import ServiceFilter from './ServiceFilter'
import moment from 'moment'
// import ItemIterator from './ItemIterator'

const currentTime = Date.now()
const dayTime = 24 * 60 * 60 * 1000

const created_end = new Date(currentTime + 15 * dayTime)
    .toISOString()
    .split('T')[0]
const created_start = new Date(currentTime - 15 * dayTime)
    .toISOString()
    .split('T')[0]

export default {
    mixins: [popupMixins],
    name: 'CustomerPortalServiceRequests',
    components: {
        // ServiceSummary,
        ServiceFilter,
        // ItemIterator,
    },
    data() {
        return {
            loading: false,
            perPage: 10,
            currentPage: 1,
            openOrders: true,
            showFilter: true,
            isCompleted: 0,
            completedStates: [
                { text: 'Active', value: 0 },
                { text: 'Closed', value: 1 },
            ],
            filters: {
                // Set Initial values
                order_type_id: 0,
                service_category: 0,
                created_start,
                created_end,
            },

        }
    },

    computed: {
        fields() {
            return [
                { label: this.$translate('actions'), key: 'id' },
                {
                    key: 'reference_no',
                    label: this.$translate('reference_no'),
                },
                {
                    key: 'order_type',
                    label: this.$translate('activity_type'),
                    formatter: (value, key, order) =>
                        order &&
                        order.type &&
                        (order.type.customer_portal_name || order.type.name),
                },
                {
                    key: 'service_category',
                    label: this.$translate('activity_category'),
                    formatter: (value, key, order) =>
                        order &&
                        order.category &&
                        (order.category.customer_portal_name ||
                            order.category.name),
                },
                {
                    key: 'description',
                    label: this.$translate('description'),
                },
                {
                    key: 'created_at',
                    label: this.$translate('created_on'),
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value),
                },
                {
                    key: 'completed_at',
                    label: this.$translate('completed_on'),
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value),
                },
              
                {
                    key: 'driver_id',
                    label: this.$translate('officer'),
                    formatter: (value, key, item) => {
                        const { first_name, last_name } = item.driver || {}
                        return `${first_name || ''} ${last_name || ''}`
                    },
                },
                {
                key: "custom_total",
                label: this.$translate("total"),
                formatter: (value, key, item) =>
                    item.items &&
                    item.items.reduce((_total, item) => {
                    const cost = item.quantity * item.price;
                    const tax_cost = (cost * item.tax_rate) / 100;
                    _total += cost + tax_cost;
                    return _total;
                    }, 0),
                class: "fw-bold",
                },
                {
                    key: 'id',
                    label: this.$translate('activity_status'),
                },
            ]
        },
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + '!important',
                color: data.text_color + '!important',
            }
            return colors
        },
        rows() {
            return this.orders.length
        },
        orders() {
            const orders = this.$store.state.customerPortal.orders
            console.log('order ---', orders)
            return orders.filter(order => {
                return (
                    this.filterOrderTypes(order) &&
                    this.filterRequestCategories(order) &&
                    this.filterDateRange(order) &&
                    this.filterCompleted(order) &&
                  
                    this.visibleOrderTypes(order)
                )
            })
        },
    },

    async mounted() {
        this.loading = true
        await this.$store.dispatch('customerPortal/fetchOrders')
        await this.$store.dispatch('orderType/customerFetchAll')
        this.loading = false
    },

    async created() {
        try {
            const userData = this.$store.state.user
            if (userData.is_first_time_login == 1) {
                this.$router.push({ name: 'CustomerProfile' })
                setTimeout(() => {
                    this.doToast(this.$translate('alert'), this.$translate('change_your_password'), 'danger')
                }, 200)
            }
        } catch (error) {
            console.error('Error checking first login:', error)
        }
    },

    watch: {
        filters: {
            handler: function () { },
            deep: true,
        },
    },
    filters: {
        filterStatusVariant(item) {
            return item.completed
                ? 'success'
                : item.released
                ? 'primary'
                : 'danger'
        },
        formatPrice: function (value) {
            let val = (value / 1).toFixed(2).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
    methods: {
        filterStatusName(item) {
            return item.completed
                ? this.$translate('completed')
                :item.draft
                ? this.$translate('drafted')
                : item.released
                ? this.$translate('processing')
                : this.$translate('pending')
        },
        officerUser(item) {
            const { first_name, last_name } = item.driver || {}
            return `${first_name || ''} ${last_name || ''}`
        },
       async createService() {
            await this.$store.dispatch('orders/clearOrderItem');
            await this.$store.dispatch('orderItemStore/clearAll');
            this.$router.push(`/customer-portal/new-service`)
        },
        users() {
            this.$router.push(`/customer-portal/users`)
        },
        formatDateTime(value) {
            const format1 = 'YYYY-MM-DD hh:mm:A'
            var date1 = new Date(value)
            return moment(date1).format(format1)
        },
        toggleOpenOrders() {
            this.openOrders = !this.openOrders
        },
        gotoDetails(id) {
            this.$router.push(`/customer-portal/view-service/${id}`)
        },
        gotoEdit(id) {
            this.$router.push(`/customer-portal/edit-service/${id}`)
        },

        filterCompleted(order) {
           if(this.isCompleted == 2){
            return order.completed === 1;
           }
           if(this.isCompleted == 0){
            return order.draft === 1;
           }
           if(this.isCompleted == 1){
            return order.draft != 1 && order.completed != 1;
           }
           
        },
       

        async filterOrderTypes(order) {
            this.loading = true
            await this.$store.commit(
                'customerPortal/updateFilter',
                this.filters.order_type_id
            )
            this.loading = false
            return (
                this.filters.order_type_id == 0 ||
                order.order_type_id === this.filters.order_type_id
            )
        },
        filterRequestCategories(order) {
            return (
                this.filters.service_category == 0 ||
                order.request_category_id === this.filters.service_category
            )
        },

        filterDateRange(order) {
            const created_end = new Date(this.filters.created_end).getTime()
            const created_start = new Date(this.filters.created_start).getTime()
            const schedule_at = new Date(order.schedule_at).getTime()
            return (
                schedule_at > created_start - dayTime &&
                schedule_at < created_end + dayTime
            )
        },

        visibleOrderTypes(order) {
            const orderTypes = this.$store.state.orderType.items
                .filter(x => !!x.is_customer_portal_visible).map(x => x.id)
                console.log("visibleOrderTypes",orderTypes.includes(order.order_type_id));
            return orderTypes.includes(order.order_type_id)
        },

        async doSearch() {
            const $this = this
            const { filters } = this
            this.loading = true
            this.$nextTick(() => {
                $this.$store.dispatch('customerPortal/fetchOrders', {
                    filters,
                })
            })
            this.loading = false
        },

        calculateOrderPrice(order) {
            const orderItems = order.items
            let orderPrice = 0

            for (let item of orderItems) {
                const basePrice = parseFloat(item.price) * item.quantity
                const tax = (basePrice * parseFloat(item.tax_rate)) / 100
                orderPrice += basePrice + tax
            }

            return orderPrice
        },
       
    },
}
</script>
